import { $fetch } from '@/boot/fetch'

const endpoint = '/returnSessionItems'

export default {
  /**
   * @description start a session for the line item
   * @function start
   * @param {string} retailerId
   * @param {string} orderNumber
   * @param {string} returnSessionId
   * @param {string} orderLineItemId
   * @returns {Promise}
   */
  start(retailerId, orderNumber, returnSessionId, orderLineItemId) {
    return $fetch.peg(`${endpoint}`, {
      method: 'POST',
      body: {
        retailerId,
        orderName: orderNumber,
        returnSessionId,
        orderLineItemId,
      },
    })
  },

  /**
   * PEG-845 (PEG-106.6): record a re-purchase CTA click-through (AC18).
   * @function recordRepurchaseCtaClick
   * @param {string} returnSessionItemId
   * @param {Object} payload
   * @param {'REPLACEMENT'|'DIFFERENT_ITEM'} payload.intent
   * @param {'PDP'|'COLLECTION'|'HOMEPAGE'} payload.linkType
   * @param {'IMMEDIATE'|'ON_RECEIPT'|null} [payload.creditState]
   * @param {'CONFIRMATION_PAGE'|'EMAIL'} [payload.source]
   * @returns {Promise}
   */
  recordRepurchaseCtaClick(returnSessionItemId, payload) {
    return $fetch.peg(`${endpoint}/${returnSessionItemId}/repurchase-cta-click`, {
      method: 'POST',
      body: payload,
      // PEG-845 (AC18): the click handler awaits this request (capped by a short
      // timeout in AppReturnRepurchaseCta) before redirecting to the storefront,
      // so the attribution POST normally completes before navigation. keepalive
      // is kept as a belt-and-suspenders fallback: if the redirect still fires
      // before the request settles within the cap, keepalive lets the POST
      // survive the page unload rather than being cancelled.
      keepalive: true,
      silent: true,
    })
  },

  /**
   * PEG-822 (AC5): record a Box Dimensions carrier-gap event (Condition A) —
   * fired when the returner has original packaging but carrier (FedEx/UPS) box
   * dimensions are unavailable, so the Box Dimensions step is shown rather than
   * skipped. Fire-and-forget telemetry for carrier-data coverage analysis; the
   * return flow never blocks on it. The server derives retailer_id from the
   * session item.
   * @function recordBoxDimsCarrierGap
   * @param {string} returnSessionItemId
   * @param {Object} payload
   * @param {'original-sealed'|'original-opened'} payload.packagingType
   * @returns {Promise}
   */
  recordBoxDimsCarrierGap(returnSessionItemId, payload) {
    return $fetch.peg(`${endpoint}/${returnSessionItemId}/box-dims-carrier-gap`, {
      method: 'POST',
      body: payload,
      // Fire-and-forget telemetry: keepalive lets the POST survive a page unload
      // (e.g. the returner navigating on quickly), silent suppresses error toasts
      // so a failed log never surfaces to or blocks the returner.
      keepalive: true,
      silent: true,
    })
  },
}
